import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Box,
  Text,
  Table,
  TableContainer,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  PopoverTrigger,
  Input,
} from "@chakra-ui/react";
import GaraazGeneralPopover from "./GaraazGeneralPopover";

type AddPartQuantityModalProps = {
  isOpen: boolean;
  onClose: () => void;
  selectedPart: any | null;
  quantity: string;
  onQuantityChange: (quantity: string) => void;
  onConfirm: () => void;
  remove_idFromPartDetails: (partObject: any) => {
    "Part Name": any;
    "Part Number": any;
    MRP: any;
    Brand: any;
    "HSN code": any;
    "Root Part Number": any;
  };
};

const AddPartQuantityModal: React.FC<AddPartQuantityModalProps> = ({
  isOpen,
  onClose,
  selectedPart,
  quantity,
  onQuantityChange,
  onConfirm,
  remove_idFromPartDetails,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Add Part Quantity</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {selectedPart && (
            <Box>
              <TableContainer>
                <Table variant="simple" size="sm">
                  <Thead>
                    <Tr>
                      <Th>Part</Th>
                      <Th textAlign={"center"}>Quantity</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    <Tr>
                      <Td>
                        <GaraazGeneralPopover
                          ArekeysVisible={true}
                          CopierKeys={[]}
                          title="Part Details"
                          value={[remove_idFromPartDetails(selectedPart)]}
                        >
                          <PopoverTrigger>
                            <Text
                              cursor={"pointer"}
                              noOfLines={1}
                              whiteSpace={"normal"}
                              fontSize={"sm"}
                              color={"#1a202c"}
                            >
                              {selectedPart.partNumber}
                            </Text>
                          </PopoverTrigger>
                        </GaraazGeneralPopover>
                      </Td>
                      <Td width={"40%"} textAlign={"center"}>
                        <Input
                          type="text"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          size="sm"
                          value={Number(quantity || "")}
                          onChange={(e) => {
                            const numValue = Math.max(
                              0,
                              parseInt(e.target.value) || 0
                            );
                            onQuantityChange(numValue.toString());
                          }}
                          min={0}
                          width="100px"
                        />
                      </Td>
                    </Tr>
                  </Tbody>
                </Table>
              </TableContainer>
            </Box>
          )}
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button
            colorScheme="blue"
            onClick={onConfirm}
            isDisabled={!quantity || parseInt(quantity) < 1}
          >
            Add Part
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddPartQuantityModal;
